import React from 'react';
import { connect } from 'react-redux';

import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import BasePage from 'apps/auth/components/utils/BasePage';
import { AUTH_SEND_MAIN_LINK } from 'apps/auth/constants/UrlConstants';
import { usePageMessages } from 'apps/auth/hooks/selectors';

const AntiFraudPepCheckPage = () => {
    const messages = usePageMessages();

    return (
        <CommonPage>
            <InfoPage
                iconName="id-card-search-80"
                iconColor="primary"
                headerText={<DangerouslyHtml dangerouslyHtml={messages.introHeaderTitle} />}
                secondaryText={<DangerouslyHtml dangerouslyHtml={messages.introText} />}
                primaryButtonCaption={messages.gotIt}
                primaryButtonType="link"
                primaryButtonLink={AUTH_SEND_MAIN_LINK}
            />
        </CommonPage>
    );
};

export default connect()(BasePage(AntiFraudPepCheckPage));
